import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export const shouldDisplayAkaRenewalInfoAlert = (
  productName: INSURANCE_NAME_VALUE,
): boolean => {
  switch (productName) {
    case INSURANCE_NAME_VALUE.AKA_CHILD:
    case INSURANCE_NAME_VALUE.AKA_CRITICAL_ILLNESS:
    case INSURANCE_NAME_VALUE.AKA_FAMILY_ACCIDENT:
    case INSURANCE_NAME_VALUE.AKA_GROUP_LIFE:
    case INSURANCE_NAME_VALUE.AKA_HOUSE_CONTENTS:
    case INSURANCE_NAME_VALUE.AKA_STUDENT:
    case INSURANCE_NAME_VALUE.AKA_TRAVEL:
      return true;
    default:
      return false;
  }
};
